import styled from "styled-components";


export const Container = styled.section`
  margin-top: 15rem;
  font-family: 'Fira Code', monospace;

  header{
    text-align: center;
    h2{
      font-size: 4rem;
      color: var(--green);
    }
  }

  .terminal-wrapper {
    max-width: 80rem;
    margin: 4rem auto 0;
    background-color: var(--terminal-bg);
    border: 1px solid var(--terminal-border);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 20px 50px rgba(0,0,0,0.3);

    .terminal-header {
      background-color: var(--terminal-header);
      padding: 1.2rem 2rem;
      display: flex;
      align-items: center;
      border-bottom: 1px solid var(--terminal-border);

      .dots {
        display: flex;
        gap: 0.8rem;
        span {
          width: 1.2rem;
          height: 1.2rem;
          border-radius: 50%;
          &:nth-child(1) { background: #ff5f56; }
          &:nth-child(2) { background: #ffbd2e; }
          &:nth-child(3) { background: #27c93f; }
        }
      }

      .title {
        flex: 1;
        text-align: center;
        font-size: 1.4rem;
        color: #6a737d;
        margin-right: 4rem; // Offset for dots to center title
      }
    }

    .terminal-body {
      padding: 3rem;
      font-size: 1.6rem;
      line-height: 2.2rem;
      color: #d1d5db;

      .line {
        margin-bottom: 0.5rem;
        &.gray { color: #6a737d; }
        &.yellow { color: #d19a66; }
        &.separator { color: var(--terminal-border); }
        &.empty { height: 1.5rem; }

        .command {
          color: var(--green);
          &::before {
            content: "";
          }
        }

        .prompt {
          color: var(--blue);
          margin-right: 1rem;
        }

        .cursor {
          display: inline-block;
          width: 8px;
          height: 1.8rem;
          background: var(--green);
          vertical-align: middle;
          animation: blink 1s step-end infinite;
        }
      }

      .endpoint {
        display: flex;
        align-items: center;
        gap: 2rem;
        margin: 1.5rem 0;
        
        .label {
          color: var(--blue);
          min-width: 8rem;
        }

        .arrow {
          color: var(--terminal-border);
        }

        .value {
          display: flex;
          align-items: center;
          gap: 1rem;
          color: #d1d5db;
          transition: 0.25s;
          
          img {
            width: 2.4rem;
            filter: grayscale(1) brightness(0.8);
            transition: 0.25s;
          }

          &:hover {
            color: var(--green);
            img {
              filter: grayscale(0) brightness(1);
            }
          }
        }
      }
    }
  }

  @keyframes blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0; }
  }

  @media(max-width: 960px){
    .terminal-wrapper {
      margin: 4rem 1rem 0;
      .terminal-body {
        padding: 2rem 1.5rem;
        font-size: 1.4rem;
        
        .endpoint {
          flex-direction: column;
          align-items: flex-start;
          gap: 0.5rem;
          margin: 2rem 0;
        }

        .separator {
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }
`
/* old one - 2/1/2023 - 
@media(max-width: 960px){
    .contacts{
      flex-direction: column;
      div{
        width: 100%;
        flex-direction: column;
      }
    }

*/
